export default __webpack_public_path__ + "static/media/KDW-template.3c014485.png";